var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.85 23.65q-.25-6.05-4.475-10.275Q30.15 9.15 24.1 8.9v-3q3.65.1 6.825 1.525Q34.1 8.85 36.5 11.25q2.4 2.4 3.825 5.575Q41.75 20 41.85 23.65Zm-8.5 0q-.25-2.5-2-4.225Q26.6 17.7 24.1 17.45v-3q3.75.25 6.375 2.85t2.875 6.35ZM39.75 42q-6.1 0-12.125-3T16.8 31.2Q12 26.4 9 20.375 6 14.35 6 8.25q0-.95.65-1.6Q7.3 6 8.25 6h7q.7 0 1.225.475.525.475.675 1.275l1.35 6.3q.1.7-.025 1.275t-.525.975l-5 5.05q2.8 4.65 6.275 8.1Q22.7 32.9 27.1 35.3l4.75-4.9q.5-.55 1.15-.775.65-.225 1.3-.075l5.95 1.3q.75.15 1.25.75T42 33v6.75q0 .95-.65 1.6-.65.65-1.6.65Z"}));
}

Phone.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Phone;

Phone.default = Phone;
